import {Button, Col, Form, Input, Modal, Result, Row, Space, Spin, Switch} from 'antd'
import ReactComponent from '../../app/ReactComponent'
import {$t, $app} from '../../app'
import TextArea from 'antd/es/input/TextArea'
import {$language, _$t} from '../../app/Languages'
import dayjs from 'dayjs'

export default class ModalBookingForm extends ReactComponent {
  state = {
    loading: false,
    first_submit: false,
    complete: false,
    tour_id: null,
    tour_data: {
      id: null,
      capacity: 0
    },
    num_of_people: 1,
    t: {}
  }

  async componentDidMount() {
    const {tour_id, tour_data} = this.props

    await this.updateState({
      tour_id,
      tour_data,
      t: {
        your_name_placeholder: await _$t("your_name_placeholder"),
        phone_placeholder: await _$t("phone_placeholder"),
        email_placeholder: await _$t("email_placeholder"),
        agreement_required: await _$t("agreement_required")
      }
    })
  }

  t(key) {
    return this.state.t.hasOwnProperty(key) ? this.state.t[key] : ""
  }

  async handleReservationFormSubmit(data) {
    const active_lang = $language().$language()
    const {
      name: tour_name = "",
      start_date: tour_start_date = "",
      end_date: tour_end_date = "",
    } = this.props.tour_data


    try {
      const res = await this.$app.$directus('tour_bookings', {
        data: {
          name: data.name,
          phone: data.phone,
          email: data.email,
          message: data.message,
          tour: this.state.tour_id,
          tour_data: {
            id: this.state.tour_id,
            name: tour_name,
            start_date: dayjs(tour_start_date).format('D.M.YYYY'),
            end_date: dayjs(tour_end_date).format('D.M.YYYY'),
          },
          language: active_lang,
        }
      })

      void this.updateState({complete: true})

      if(this.props.hasOwnProperty("handleTourReload"))
        this.props.handleTourReload()


    } catch (e) {

      this.handleError(e)

      //console.log(e)

    }

  }

  render() {
    const {open, handleClose} = this.props

    return (
      <>
        <Modal
          title={<h3>
            <$t _="booking_form_title"/>
          </h3>}
          open={open}
          size
          onCancel={() => {
            handleClose()
          }}
          footer={null}
          width={640}
        >

          {this.state.complete ?

            <Result
              status="success"
              title={<$t _="booking_form_complete_title"/>}
              subTitle={<$t _="booking_form_complete_subtitle"/>}
              extra={<Button type="link" onClick={handleClose}><$t _="booking_form_done"/></Button>}
            />

            :

            <>
              <p className="ta-center mb-3 _grey-primary-text">
                <$t _="booking_form_subtitle"/>
              </p>
              <Form
                onFinish={(...args) => this.handleReservationFormSubmit(...args)}
                onFinishFailed={() => {
                  void this.updateState({first_submit: true})
                }}
                scrollToFirstError={true}
                layout="vertical"
              >
                <Form.Item
                  name="name"
                  label={<$t _="your_name"/>}
                  rules={[{required: true, message: <$t _="name_required"/>}]}
                >
                  <Input placeholder={this.t('your_name_placeholder')}/>
                </Form.Item>

                <Row gutter={16}>
                  <Col xs={24} sm={12}>

                    <Form.Item
                      name="email"
                      label={<$t _="your_mail"/>}
                      rules={[{required: true, message: <$t _="email_required"/>}]}
                    >
                      <Input placeholder={this.t('email_placeholder')}/>
                    </Form.Item>

                  </Col>
                  <Col xs={24} sm={12}>

                    <Form.Item
                      name="phone"
                      label={<$t _="your_phone"/>}
                      rules={[{required: true, message: <$t _="phone_required"/>}]}
                    >
                      <Input placeholder={this.t('phone_placeholder')}/>
                    </Form.Item>

                  </Col>
                </Row>

                {/*<Form.Item
              name="people_count"
              label="Počet míst">
              <Flex gap={5} flex="2em 1">
                <InputNumber
                  name="people_count"
                  min={1}
                  max={this.state.tour_data.capacity}
                  style={{margin: '0 16px 0 0'}}
                  value={this.state.num_of_people}
                  onChange={(value) => void this.updateState({num_of_people: value})}
                />
                <Slider
                  min={0}
                  max={this.state.tour_data.capacity}
                  value={this.state.num_of_people}
                  onChange={(value) => void this.updateState({num_of_people: value})}
                  style={{flexGrow: 1}}
                />
              </Flex>
            </Form.Item>
            */
                }

                <Form.Item
                  name="message"
                  label={<$t _="booking_form_additional_info_label"/>}>
                  <TextArea
                    autoSize={{minRows: 5, maxRows: 12}}
                  />
                </Form.Item>

                <Form.Item
                  className="switch-container"
                >
                  <Form.Item
                    name="agreement"
                    valuePropName="checked"
                    noStyle
                    rules={[{
                      validator: (_, value) =>
                        value ? Promise.resolve() : Promise.reject(new Error(this.t('agreement_required'))),
                    },]}>
                    <Switch id="agreement"/>
                  </Form.Item>
                  <label htmlFor="agreement">
                    <$t _="booking_form_agreement"/>
                  </label>
                </Form.Item>

                <div className="ta-right">
                  <Space size="large">
                  <Button type="link" htmlType="submit" onClick={handleClose}>
                      <$t _="booking_form_cancel_button"/>
                    </Button>
                    <Spin spinning={this.state.loading}>
                      <Button type="primary" htmlType="submit">
                        <$t _="booking_form_submit_button"/>
                      </Button>
                    </Spin>
                  </Space>
                </div>
              </Form>
            </>

          }

        </Modal>
      </>
    )
  }
}